<app-layout>
<div class="card border-left" >
  <div class="col-12 md:col-12 d-flex justify-content-between flex-wrap">
    <span class="h4 fw-bold text-primary">
      <i class="fa fa-graduation-cap me-2"></i>
      Pestforce Academy - Vista Previa
    </span>

    <a routerLink="/academy" class="btn btn-sm bg-primary">
      <i class="fa fa-arrow-left me-1"></i> Volver
    </a>
  </div>

  <div class="pb-5">
    <div class="row">
      <div class="col-12">
        <div class="card shadow-sm">
          <div class="card-body p-0">
            <div class="ratio ratio-16x9">
              <iframe
                *ngIf="videoUrl && getVideoType() === 'youtube'"
                [src]="videoUrl"
                title="Video del curso"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              >
              </iframe>

              <video
                *ngIf="videoUrl && getVideoType() === 'html5'"
                controls
                autoplay
                class="w-100 h-100">
                <source [src]="videoSrc" type="video/mp4"
              >
                Tu navegador no soporta el elemento de video.
              </video>

              <iframe
                *ngIf="videoUrl && getVideoType() === 'iframe'"
                [src]="videoUrl"
                title="Video del curso"
                frameborder="0"
                allowfullscreen
                class="w-100 h-100"
              >
              </iframe>

              <div *ngIf="!videoUrl" class="d-flex justify-content-center align-items-center bg-light">
                <div class="text-center p-4">
                  <i class="fa fa-video-camera fa-3x text-muted mb-3"></i>
                  <p class="h5 text-muted">No se ha proporcionado un video para previsualizar</p>
                  <a routerLink="/pestforce-academy" class="btn btn-primary mt-3">
                    <i class="fa fa-arrow-left me-2"></i> Volver a los cursos
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="card-footer bg-white mt-4">
            <div class="d-flex justify-content-between align-items-center">
              <small class="text-muted">Vista previa del curso</small>

              <a routerLink="/academy" class="btn btn-sm bg-primary">
                <i class="fa fa-arrow-left me-1"></i> Volver
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</app-layout>